
import { css } from 'lit';
export default css`
:host{
  --testimonial-image-width-mobile:64px;
  --testimonial-image-width:296px;

  --testimonial-border-width-mobile:3px;
  --testimonial-border-width:4px;

  --testimonial-text-color:var(--neutral-charcoal);
  --testimonial-padding-bottom:var(--spacing-16);

  --testimonial-image-size:296px;
  --testimonial-quote-min-height:277px;

  --testimonial-border-color:var(--purple-indigo-light);

  display:block;
}

.testimonial{
  padding-top:var(--spacing-8);
  padding-bottom:var(--spacing-18);
}

.content{
  position:relative;
}

.quote{
  display:flex;
  position:relative;
  flex-direction:column;
  justify-content:center;
  gap:var(--spacing-4);
  box-sizing:border-box;
  margin:0;
  border:var(--testimonial-border-width-mobile) solid var(--testimonial-border-color);
  border-right:0;
  border-left:0;
  padding:var(--spacing-8);
}

.quote footer{
  display:flex;
  align-items:center;
  gap:var(--spacing-8);
}

.image{
  display:none;
  position:absolute;
  right:var(--spacing-8);
  bottom:var(--spacing-8);
}

.image--mobile{
  width:var(--testimonial-image-width-mobile);
}

.without-image .image,
.without-image .image--mobile{
  display:none;
}

::slotted([slot='nav']){
  margin-bottom:var(--spacing-6);
  margin-left:var(--spacing-8);
  color:var(--purple-indigo-light);
}

::slotted([slot='content']),
::slotted([slot='footer']){
  color:var(--testimonial-text-color);
}

.is-reversed{
  --testimonial-text-color:var(--primary-white);
}

@media (min-width: 992px){
  .testimonial{
    padding-top:var(--spacing-8);
    padding-bottom:calc(var(--spacing-24) - var(--testimonial-border-width));
  }

  .container{
    display:grid;
    grid-template-columns:calc((10 / 12) * 100%);
    justify-content:center;
    gap:0;
  }

  .content{
    position:relative;
    padding-right:18%;
  }

  .image{
    display:block;
    position:absolute;
    top:var(--spacing-12);
    right:0;
    width:var(--testimonial-image-size);
  }

  .quote{
    gap:var(--spacing-6);
    margin:0;
    border:4px solid var(--testimonial-border-color);
    padding:var(--spacing-8) 24% var(--spacing-8) var(--spacing-8);
    min-height:var(--testimonial-quote-min-height);
  }

  .quote::after{
    display:block;
    position:absolute;
    right:-130px;
    bottom:calc(var(--testimonial-padding-bottom) * -1);
    box-sizing:border-box;
    border:4px solid var(--testimonial-border-color);
    border-radius:0 64px 64px 0;
    width:130px;
    height:var(--testimonial-padding-bottom);
    content:'';
  }

  ::slotted([slot='image-mobile']){
    display:none;
  }

  .without-image .container{
    grid-template-columns:calc((8 / 12) * 100%);
  }

  .without-image .content{
    padding-right:0;
  }

  .without-image .quote{
    padding:var(--spacing-8) var(--spacing-16) var(--spacing-8) var(--spacing-8);
    min-height:auto;
  }
}

@media (min-width: 1280px){
  .quote{
    padding:var(--spacing-8) 18% var(--spacing-8) var(--spacing-8);
  }
}
`;